module.exports = __webpack_public_path__ + "static/media/hilda_sw.6e28bce9.jpg";